module.exports = __webpack_public_path__ + "static/img/l-panlb-icon.73430b2e.png";